import { render, staticRenderFns } from "./TabelaDadosExpanded.vue?vue&type=template&id=25373d49"
import script from "./TabelaDadosExpanded.vue?vue&type=script&lang=js"
export * from "./TabelaDadosExpanded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports